import URLSearchParams from 'url-search-params';

export default (endpoint, body) => {
  const params = new URLSearchParams(window.location.search);
  let finalBody = body;

  if (params.has('continue')) {
    finalBody = `${body}&continue=${encodeURIComponent(params.get('continue'))}`;
  }

  return fetch(endpoint, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: finalBody
  });
};
